import React from 'react';

const ProductMasterPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default ProductMasterPage;
